/***
 * @returns {Video} 视频类
 * @param {*} params 配置参数
 * @param {*} params.el 视频元素
 * @param {*} params.id 视频dataId
 */
class Video {
  static playButton = "skt-vidoe-play";

  constructor(params) {
    this.video = params.el;
    this.id = params.el.dataset.id;
  }

  /**
   * 播放
   * @param {*} fn 回调函数
   */
  play(fn) {
    this.video.play();
    fn && fn();
  }
  /**
   * 暂停
   * @param {*} fn 回调函数
   */
  pause(fn) {
    this.video.pause();
    fn && fn();
  }
  /**
   * 加载
   */
  load() {
    this.video.load();
  }
  /**
   * 开启声音
   */
  openMuted() {
    this.video.muted = false;
  }
  /**
   * 关闭声音
   */
  closeMuted() {
    this.video.muted = true;
  }
  /**
   * 重新播放
   */
  replayVideo() {
    this.video.currentTime = 0;
    this.video.play();
  }

  /**
   * 修改播放按钮的状态
   * @param {*} palyButon 播放按钮元素
   */
  setPlayButtonState(palyButon) {
    palyButon.dataset.state = this.video.paused ? "play" : "pause";
  }

  /**
   * 点击代理事件
   *  @param {String} proxyElement 代理容器元素classId
   *  @param {Function} callback 回调函数
   * */
  static clickHandle(proxyElement, callback) {
    const _proxyElement = document.querySelector(proxyElement);

    // 不存在代理元素
    if (!_proxyElement) return;
    
    _proxyElement.addEventListener("click", (e) => {
      const _target = e.target;
      if (_target.className.indexOf(Video.playButton) == -1) return;
      const _id = _target.dataset.id;
      callback && callback(_id, _target);
    });
  }
}

/**
 * 手风琴
 * @param {*} options 配置
 *  buttonClass {String}按钮
 *  contentClass {String} 内容盒子
 *  contentInnerClass {String} 内容文本盒子
 *  closeBefore {Boolean} 关闭其他
 * @param {*} openCallback 打开回调
 * @param {*} closeCallback 关闭回调
 */
function Accordion(
  { buttonClass, contentClass, contentInnerClass, closeBefore } = {
    closeBefore: false,
  },
  openCallback,
  closeCallback
) {
  // 判断是否使用new关键字调用
  if (!new.target) {
    throw new Error("必须使用new关键字调用Accordion");
  }

  // // 判断是否是实例化
  // if (new.target.prototype !== Accordion.prototype) {
  //   throw new Error("Accordion不能被实例化");
  // }

  const $collapsibleButtons = document.querySelectorAll(buttonClass);
  let beforeIndex = -1;
  for (let i = 0; i < $collapsibleButtons.length; i++) {
    const button = $collapsibleButtons[i];
    init(button);
    button.addEventListener("click", function (e) {
      e.preventDefault();
      const expanded = JSON.parse($(this).attr("aria-expanded"));

      // 关闭
      if (expanded) {
        $(this).attr("aria-expanded", "false");
        $(this).siblings(contentClass).height(0);
        // 关闭回调
        closeCallback && closeCallback(i, beforeIndex);
        beforeIndex = i;
        return;
      }

      // 开启
      $(this).attr("aria-expanded", true);
      const collapsibleContent = $(this).siblings(contentClass),
        contactHeight =
          $(collapsibleContent).children(contentInnerClass)[0].clientHeight;
      $(collapsibleContent).height(contactHeight);
      // 打开回调
      openCallback && openCallback(i, beforeIndex);
      // 关闭其他
      closeBefore && closeBeforeItem();
      beforeIndex = i;
    });
  }

  const closeBeforeItem = () => {
    if (beforeIndex === -1) return; // 没有打开的yo
    $($collapsibleButtons).eq(beforeIndex).attr("aria-expanded", "false");
    $($collapsibleButtons).eq(beforeIndex).siblings(contentClass).height(0);
  };

  /**
   * 初始化
   * @param {*} button 开启的按钮
   */
  function init(button) {
    const expanded = JSON.parse($(button).attr("aria-expanded"));
    if (expanded) {
      const collapsibleContent = $(button).siblings(contentClass),
        contactHeight =
          $(collapsibleContent).children(contentInnerClass)[0].clientHeight;
      $(collapsibleContent).height(contactHeight);
    }
  }
}

/**
 * 产品类
 * @param {*} data 产品数据
 * @returns {Product} 产品类
 */
class CardProduct {
  constructor(data) {
    this.productData = data;
  }

  /**
   * 更新购物车
   * @param item: {id: 1, quantity: 1}
   * @param {*} URL 接口地址
   * @returns Promise
   */
  static updateCart(items, url = "cart/add.js") {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: "POST",
        url: window.Shopify.routes.root + url,
        data: items,
        dataType: "json",
        success: function (response) {
          resolve(response);
        },
        error: function (error) {
          reject(error);
        },
      });
    });
  }

  /**
   * 容器点击事件
   * @param {String} proxyContainerId 代理容器ID
   * @param {Function} callbackFn 回调函数 [{id: 1, quantity: 1}]
   * @param {String} productAddButtonElementProperty 产品添加按钮属性
   * @returns void
   */
  static clickHandle(
    proxyContainerId,
    callbackFn,
    productAddButtonElementProperty = "add-product-button"
  ) {
    const proxyContainer = document.querySelector(proxyContainerId);
    $(proxyContainer).click(function (e) {
      const _target = e.target;
      const isAddProductButton = $(_target).data(
        productAddButtonElementProperty
      );
      if (isAddProductButton) {
        const item = {
          id:
            $(_target).data("product-variant-id") ||
            proxyContainer.querySelector('input[name="id"]').value,
          quantity:
            $(_target).data("quantity") ||
            proxyContainer.querySelector('input[name="quantity"]').value,
        };
        callbackFn && callbackFn(item);
      }
    });
  }

  /**
   * 获取购物车产品
   * @returns Promise
   */
  static getCartItems() {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: "GET",
        url: window.Shopify.routes.root + "cart.js",
        dataType: "json",
        success: function (response) {
          resolve(response.items);
        },
      });
    });
  }
}

// 更新倒计时的函数
function Countdown(expireDate, options) {
  this.expireDate = expireDate;
  this.options = options;
  this.countdownInterval = null;
  this.timeRemaining = 0;

  // 判断是否使用new关键字调用
  if (!new.target) {
    throw new Error("必须使用new关键字调用Accordion");
  }

  // 目标日期和时间
  const targetDate = new Date(this.expireDate).getTime();

  function update() {
    // 当前日期和时间
    var currentDate = new Date().getTime();

    // 目标日期和当前日期之间的时间差
    this.timeRemaining = targetDate - currentDate;

    // 将倒计时显示在页面上
    this.setDateElement(this.getDate());

    // 如果目标日期已过去，则停止倒计时
    if (this.timeRemaining <= 0) {
      clearInterval(this.countdownInterval);
    }
  }

  // 每秒钟更新一次倒计时
  this.countdownInterval = setInterval(() => update.call(this), 1000);
}

/**
 * 获取日期
 * @returns {Object} 日期
 */
Object.defineProperty(Countdown.prototype, "getDate", {
  enumerable: false, //不可枚举
  configurable: false, //不可配置
  writable: false, //不可修改
  value: function () {
    if (new.target) {
      throw new Error("getDate函数不能使用 new关键字调用");
    }

    // 计算剩余的天、小时、分钟和秒
    const days = Math.floor(this.timeRemaining / (1000 * 60 * 60 * 24)),
      hours = Math.floor(
        (this.timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      ),
      minutes = Math.floor(
        (this.timeRemaining % (1000 * 60 * 60)) / (1000 * 60)
      ),
      seconds = Math.floor((this.timeRemaining % (1000 * 60)) / 1000);
    return {
      days: (this.timeRemaining <= 0 ? 0 : days).toString().padStart(2, "0"),
      hours: (this.timeRemaining <= 0 ? 0 : hours).toString().padStart(2, "0"),
      minutes: (this.timeRemaining <= 0 ? 0 : minutes)
        .toString()
        .padStart(2, "0"),
      seconds: (this.timeRemaining <= 0 ? 0 : seconds)
        .toString()
        .padStart(2, "0"),
    };
  },
});

/**
 * 设置日期元素
 * @param {*} _date 日期
 */
Object.defineProperty(Countdown.prototype, "setDateElement", {
  enumerable: false, //不可枚举
  configurable: false, //不可配置
  writable: false, //不可修改
  value: function (_date) {
    $(this.options._days).text(_date.days);
    $(this.options._hours).text(_date.hours);
    $(this.options._minutes).text(_date.minutes);
    $(this.options._seconds).text(_date.seconds);
  },
});
